module.exports = __webpack_public_path__ + "img/hero.12a885aa.jpg";